/**
 * @file Common setup for tests and main
 */

import Vue from 'vue'
import VueRouter from 'vue-router'
import VueTouch from 'vue-touch'
import VueObserveVisibility from 'vue-observe-visibility'
import VueUniqueId from 'vue-unique-id'
import VueVisible from 'v-visible'
import eventBus from './services/eventbus'
import EventBusMixin from './components/EventBusMixin.vue'
import log from './services/log'

Vue.config.productionTip = false

// Register two custom events in addition to the standard 'tap'. Even though
// 'singletap' seems the same as 'tap' it's different because it pauses to
// require the failure of 'doubletap'. See Reader.mounted which applies the
// extra constraints to the hammer instance.
VueTouch.registerCustomEvent('singletap', {
  type: 'tap',
  taps: 1,
  threshold: 10, // default 2
})

VueTouch.registerCustomEvent('doubletap', {
  type: 'tap',
  taps: 2,
  threshold: 10, // default 2
  posThreshold: 20, // default 10
  interval: 300, // default 300
})

Vue.use(VueTouch, {
  name: 'v-touch',
})

Vue.use(VueUniqueId)

Vue.use(VueVisible)

// Install <router-view> and <router-link>, and inject $router and
// $route to all router-enabled child components. Not for tests, though, see
// https://vue-test-utils.vuejs.org/guides/using-with-vue-router.html and
// https://stackoverflow.com/a/55544290/347386
if (process.env.NODE_ENV !== 'test') {
  Vue.use(VueRouter)
}

// Enable v-observe-visibility directive.
Vue.use(VueObserveVisibility)

// EventBusMixin provides this.$pub and this.$sub to all components.
Vue.mixin(EventBusMixin)

// Components can call this.$pub('error', e) to send an error report to
// rollbar. This is especially for unexpected API responses.
eventBus.$on('error', log.error)

// Vue catches exceptions in components. This is similar to window.onerror
// but just for components. https://rollbar.com/blog/error-tracking-vue-js/
//
// Don't set this for tests, otherwise we get the warning:
//   Vue Test Utils sets a custom error handler to throw errors thrown by
//   instances. If you want this behavior in your tests, you must remove the
//   global error handler.
if (process.env.NODE_ENV !== 'test') {
  Vue.config.errorHandler = log.error
}
